module.exports = __webpack_public_path__ + "img/graph.0f8afd26.svg";